import React from 'react'
import moment from 'moment'
import cn from 'classnames'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

import { format } from '../utils/number'
import { DATETIME_FORMAT } from '../utils/date'
import { getMeasurement } from '../utils/types'
import Button from '../components/common/Button'

export default function ArchiveOrderInfo({ item, onCancel }) {
    // Calculate actual total (excluding returned items)
    const actualTotal = item?.orderProduct?.reduce((sum, prod) => {
        const soldQuantity = prod.count - (prod.returnedAmount || 0)
        return sum + (soldQuantity * prod.price)
    }, 0) || 0

    return (
        <>
            <main style={{ marginBottom: 100 }}>
                {item?.client && (
                    <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                        <b>Клиент:</b>
                        <span style={{ fontWeight: 500 }}>{item.client?.name}</span>
                    </p>
                )}
                <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                    <b>Дата:</b>
                    <span style={{ fontWeight: 500 }}>{moment(item?.createdAt).format(DATETIME_FORMAT)}</span>
                </p>
                <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                    <b>ID-чека:</b>
                    <span style={{ fontWeight: 500 }}>{item?.codeContent}</span>
                </p>

                <div style={{ height: 1, backgroundColor: 'black', margin: '8px 0' }} />

                {item?.orderProduct?.map((prod, i) => (
                    <div key={prod?.id} style={{ marginBottom: '1rem' }}>
                        <h3 className={cn(prod.type === 'sold' ? 'has-text-black' : 'has-text-danger')} style={{ fontWeight: 'bold', textDecoration: prod?.returnedAmount >= prod?.count && 'line-through' }}>
                            {i + 1}. {prod?.product?.name}
                        </h3>

                        <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                            <span>Цена:</span>
                            <span style={{ fontWeight: 500 }}>
                                {prod?.count - (prod?.returnedAmount || 0)} {getMeasurement(prod?.product?.measurement)} x {format(prod?.price)} {item?.currency === 'usd' ? 'USD' : 'Сум'} ={' '}
                                <b>
                                    {format((prod?.count - (prod?.returnedAmount || 0)) * prod.price)} {item?.currency === 'usd' ? 'USD' : 'Сум'}
                                </b>
                            </span>
                        </p>
                        {prod?.returnedAmount > 0 && (
                            <p style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', fontSize: '0.9em', color: '#dc3545' }}>
                                <span>Возвращено:</span>
                                <span>{prod?.returnedAmount} {getMeasurement(prod?.product?.measurement)}</span>
                            </p>
                        )}
                    </div>
                ))}

                <div style={{ height: 1, backgroundColor: 'black', margin: '10px 0' }} />

                <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '16px',
                    borderRadius: '8px',
                    border: '1px solid #e9ecef',
                    marginTop: '16px'
                }}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '12px 0',
                        borderBottom: '2px solid #007bff',
                        marginBottom: '12px'
                    }}>
                        <span style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#007bff'
                        }}>
                            Итого:
                        </span>
                        <span style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#007bff'
                        }}>
                            {format(actualTotal)} {item?.currency === 'usd' ? 'USD' : 'Сум'}
                        </span>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '8px 0',
                        borderBottom: '1px solid #dee2e6'
                    }}>
                        <span style={{
                            fontWeight: '600',
                            color: '#dc3545'
                        }}>
                            Сумма долга:
                        </span>
                        <span style={{
                            fontWeight: 'bold',
                            color: '#dc3545'
                        }}>
                            {format(item?.debtAmount ? item?.debtAmount : 0)} {item?.currency === 'usd' ? 'USD' : 'Сум'}
                        </span>
                    </div>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '8px 0'
                    }}>
                        <span style={{
                            fontWeight: '600',
                            color: '#28a745'
                        }}>
                            Оплаченная сумма:
                        </span>
                        <span style={{
                            fontWeight: 'bold',
                            color: '#28a745'
                        }}>
                            {format(item?.sumComing - item?.debtAmount)} {item?.currency === 'usd' ? 'USD' : 'Сум'}
                        </span>
                    </div>
                </div>
            </main>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', padding: '20px', position: 'absolute', bottom: 0, left: 0, background: 'white', width: '100%', borderTop: '1px solid whitesmoke' }}>
                <Button onClick={onCancel} text="Отмена" className="is-outlined" />
                <Link onClick={onCancel} to={`/archive/order/${item.id}`} className="button is-danger is-block">
                    Возврат
                </Link>
            </div>
        </>
    )
}
